(() => {
  const header = document.querySelector('[data-h3d-header]');
  const toggle = document.querySelector('[data-h3d-nav-toggle]');
  const nav = document.querySelector('[data-h3d-shop-nav]');
  if (!header) return;

  const syncHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 12);
  syncHeader();
  window.addEventListener('scroll', syncHeader, { passive: true });

  if (!toggle || !nav) return;

  const closeNav = () => {
    document.body.classList.remove('h3d-nav-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Menü öffnen');
  };

  toggle.addEventListener('click', () => {
    const open = !document.body.classList.contains('h3d-nav-open');
    document.body.classList.toggle('h3d-nav-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
  });

  nav.addEventListener('click', (event) => {
    if (event.target.closest('a')) closeNav();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeNav();
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 1160) closeNav();
  });
})();

